import { render } from "./RegisterFormPro.vue?vue&type=template&id=4215ca57"
import script from "./RegisterFormPro.vue?vue&type=script&lang=js"
export * from "./RegisterFormPro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__